module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/path-to-regexp/node_modules/isarray/index.js
// module id = ./node_modules/path-to-regexp/node_modules/isarray/index.js
// module chunks = vendor